"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeleteChatEventKey = exports.getUpdateChatEventKey = exports.getNewChatEventKey = exports.filteredGroupEventKey = exports.groupEventKey = exports.getChatLogUpdateKey = exports.getChatMessageReadKey = exports.getEventKey = exports.DomainEvents = exports.SocketStatusEvents = exports.SocketNetworkEvents = void 0;
exports.SocketNetworkEvents = {
    ON_CONNECT: "connect",
    ON_DISCONNECT: "disconnect",
    ON_PONG: "pong",
    ON_RECONNECT_ATTEMPT: "reconnect-attempt",
    ON_RECONNECT_FAILED: "reconnect-failed",
    ON_AUTHENTICATE_SUCCEEDED: "authenticate-succeeded",
};
exports.SocketStatusEvents = {
    ON_CHANGE: "on-socket-status-change",
    DISCONNECTED_PENDING_RETRY: "on-socket-disconnected-pending-retry",
};
exports.DomainEvents = {
    NEW_CHAT_LIST_GROUP_PATIENT: "new-chat-list-group-patient",
    NEW_CHAT_LIST_PRIVATE: "new-chat-list-private",
    NEW_CHAT_LIST_GROUP_NON_PATIENT: "new-chat-list-group-non-patient",
    NEW_CHAT_LIST_BROADCAST: "new-chat-list-broadcast",
    UPDATE_CHAT_LIST_GROUP_PATIENT: "update-chat-list-group-patient",
    UPDATE_CHAT_LIST_PRIVATE: "update-chat-list-private",
    UPDATE_CHAT_LIST_GROUP_NON_PATIENT: "update-chat-list-group-non-patient",
    UPDATE_CHAT_LIST_BROADCAST: "update-chat-list-broadcast",
    UPDATE_CHAT_LIST_GROUP_HIDDEN: "update-chat-list-group-hidden",
    DELETE_CHAT_LIST_BROADCAST: "delete-chat-list-broadcast",
    RECEIVE_MESSAGE: "receive-message",
    SEND_MESSAGE: "send-message",
    RESPONSE_ERROR: "response-error",
    SLOW_MESSAGE_SEND: "slow-message-send",
    ORG_COUNTERS: "org-counters",
    USER_DIRECTORY_UPDATE: "user_directory_update",
    PRIVATE_CHAT_LIST: "private-chat-list",
    NON_PATIENT_CHAT_LIST: "non-patient-chat-list",
    PATIENT_CHAT_LIST: "patient-chat-list",
    HIDDEN_CHAT_LIST: "hidden-chat-list",
    BROADCAST_CHAT_LIST: "broadcast-chat-list",
    FILTERED_PRIVATE_CHAT_LIST: "filtered-private-chat-list",
    FILTERED_NON_PATIENT_CHAT_LIST: "filtered-non-patient-chat-list",
    FILTERED_PATIENT_CHAT_LIST: "filtered-patient-chat-list",
    FILTERED_HIDDEN_CHAT_LIST: "filtered-hidden-chat-list",
    FILTERED_BROADCAST_CHAT_LIST: "filtered-broadcast-chat-list",
    NEW_ALERT: "new-alert",
    NEW_ACKNOWLEDGE_ALERT: "new-acknowledge-alert",
    ALERT_REMOVE: "alert-remove",
    UPDATE_MESSAGE: "update-message",
    DELETE_MESSAGE: "delete-message",
    ALERT_REMOVE_ACKNOWLEDGEMENT: "alert-remove-acknowledgement",
    NO_PENDING_ACKNOWLEDGEMENT: "no-pending-acknowledgement",
    ALERT_UPDATE: "alert-update",
    // UPDATE_GROUP: "group-update",
    UPDATE_GROUP: "v2-group-update",
    UPDATE_CHAT_LIST_ITEM: "update-chat-list-item",
    CHAT_MESSAGE_READ: "chat-message-read",
    CHAT_LOG_UPDATE: "chat-log-update",
    HIDE_CHAT: "hide-chat",
    UNHIDE_CHAT: "unhide-chat",
    STAR_MESSAGE: "star-message",
    UNSTAR_MESSAGE: "unstar-message",
    UNSTAR_SINGLE_MESSAGE: "unstar-single-message",
    UNSTAR_ALL_MESSAGES: "unstar-all-messages",
    MARK_AS_DELIVERED: "mark-as-delivered",
    MESSAGE_DELIVERED: "message-delivered",
    MESSAGE_READ: "message-read",
    USER_UPDATE: "user-update",
    ALERT_DELETE: "alert-delete", // used when chat is deleted
};
const getEventKey = (key, id) => `${key}:${id}`;
exports.getEventKey = getEventKey;
const getChatMessageReadKey = (type) => `${type}_${exports.DomainEvents.CHAT_MESSAGE_READ}`;
exports.getChatMessageReadKey = getChatMessageReadKey;
const getChatLogUpdateKey = (orgId, chatType, groupType) => {
    let eventKey = chatType;
    if (groupType) {
        eventKey += `_${groupType}`;
    }
    return (0, exports.getEventKey)(`${eventKey}_${exports.DomainEvents.CHAT_LOG_UPDATE}`, orgId);
};
exports.getChatLogUpdateKey = getChatLogUpdateKey;
const groupEventKey = (orgId, type) => {
    return (0, exports.getEventKey)(exports.DomainEvents[`${type}_CHAT_LIST`], orgId);
};
exports.groupEventKey = groupEventKey;
const filteredGroupEventKey = (type) => {
    return exports.DomainEvents[`FILTERED_${type}_CHAT_LIST`];
};
exports.filteredGroupEventKey = filteredGroupEventKey;
const getChatEventKey = (prefix, orgId, chatType, groupType) => {
    let eventKey = prefix + chatType;
    if (groupType) {
        eventKey += `_${groupType}`;
    }
    return (0, exports.getEventKey)(exports.DomainEvents[eventKey], orgId);
};
const getNewChatEventKey = (orgId, chatType, groupType) => {
    return getChatEventKey("NEW_CHAT_LIST_", orgId, chatType, groupType);
};
exports.getNewChatEventKey = getNewChatEventKey;
const getUpdateChatEventKey = (orgId, chatType, groupType) => {
    return getChatEventKey("UPDATE_CHAT_LIST_", orgId, chatType, groupType);
};
exports.getUpdateChatEventKey = getUpdateChatEventKey;
const getDeleteChatEventKey = (orgId, chatType, groupType) => {
    return getChatEventKey("DELETE_CHAT_LIST_", orgId, chatType, groupType);
};
exports.getDeleteChatEventKey = getDeleteChatEventKey;
